import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Reusable Stimulus controller for Bootstrap modals
//
// Basic usage:
// <div class="modal fade" data-controller="modal" data-modal-show-value="true">
//   <div class="modal-dialog">
//     <div class="modal-content">
//       <div class="modal-header">
//         <h5 class="modal-title">Modal Title</h5>
//         <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
//       </div>
//       <div class="modal-body">
//         <p>Modal content here...</p>
//       </div>
//       <div class="modal-footer">
//         <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//         <button type="button" class="btn btn-primary">Save changes</button>
//       </div>
//     </div>
//   </div>
// </div>
//
// Available data attributes:
// - data-modal-show-value="true"           # Auto-show modal on page load
// - data-modal-backdrop-value="static"    # Prevent closing on backdrop click
// - data-modal-keyboard-value="false"     # Disable ESC key closing
// - data-modal-focus-value="false"        # Disable auto-focus
//
// Available actions (call from other controllers):
// - data-action="click->modal#show"       # Show modal
// - data-action="click->modal#hide"       # Hide modal
// - data-action="click->modal#toggle"     # Toggle modal visibility
//
// Example with custom button trigger:
// <button data-action="click->modal#show" data-modal-target="welcomeModal">
//   Show Welcome Modal
// </button>

export default class extends Controller {
  static values = { 
    show: { type: Boolean, default: false },
    backdrop: { type: String, default: "true" },
    keyboard: { type: Boolean, default: true },
    focus: { type: Boolean, default: true }
  }

  connect() {
    this.modal = new Modal(this.element, {
      backdrop: this.backdropValue,
      keyboard: this.keyboardValue,
      focus: this.focusValue
    })

    if (this.showValue) {
      this.show()
    }
  }

  disconnect() {
    if (this.modal) {
      this.modal.dispose()
    }
  }

  show() {
    this.modal.show()
  }

  hide() {
    this.modal.hide()
  }

  toggle() {
    this.modal.toggle()
  }
}